import { useLanguage } from "@/i18n/LanguageContext";

export default function Marquee() {
  const { t } = useLanguage();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div data-testid="marquee-ribbon" className="bg-slate-50 border-y border-slate-200 overflow-hidden py-5">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {row.map((t, i) => (
          <span key={i} className="font-serif-display text-lg text-slate-800 mx-6 flex items-center">
            {t}
            <span className="text-brand-600 ml-12">•</span>
          </span>
        ))}
      </div>
    </div>
  );
}
